import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { LineCardHeader } from "./LineCardHeader";
import { LineCardExpanded } from "./LineCardExpanded";
import type { LineSummary, MachineDetail } from "@/types/lines.types";

export interface LineCardProps {
  line: LineSummary;
  expanded: boolean;
  onToggleExpand: () => void;
  onMachineClick: (m: MachineDetail) => void;
  selected?: boolean;
  onToggleSelect?: () => void;
}

export function LineCard({
  line,
  expanded,
  onToggleExpand,
  onMachineClick,
  selected,
  onToggleSelect,
}: LineCardProps): React.ReactElement {
  return (
    <Card
      className={cn(
        "animate-fade-in transition-shadow",
        expanded
          ? "shadow-[0_4px_12px_rgba(20,18,30,0.05)]"
          : "hover:shadow-[0_1px_2px_rgba(20,18,30,0.04)]"
      )}
    >
      <CardContent className="p-0">
        <LineCardHeader
          line={line}
          expanded={expanded}
          onToggleExpand={onToggleExpand}
          onMachineClick={onMachineClick}
          selected={selected}
          onToggleSelect={onToggleSelect}
        />
        {expanded ? <LineCardExpanded line={line} onMachineClick={onMachineClick} /> : null}
      </CardContent>
    </Card>
  );
}
